import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '@/store'

Vue.use(VueRouter);

// const isAuthenticated = (to, from, next) => {
//   if (store.state.auth.isAuthenticated) {
//     next();
//     return
//   }
//   next('/sing-in')
// };

const routes = [
    {
        path: '/:lang?',
        name: 'home',
        component: () => import('../modules/home/index.vue'),
    },
    {
        path: '/:lang?/thanks',
        name: 'thanks',
        component: () => import('@/modules/thanks/index.vue'),
    },
    {
        path: '/:lang?/catalog',
        name: 'catalog',
        component: () => import('@/modules/catalog/index.vue'),
    },
    {
        path: '/:lang?/about',
        name: 'about',
        component: () => import('@/modules/about/index.vue'),
    },
    {
        path: '/:lang?/news',
        name: 'news',
        component: () => import('@/modules/news/index.vue'),
    },
    {
        path: '/:lang?/news/read-more/:slug',
        name: 'read-more',
        component: () => import('@/modules/news/read-more/index.vue'),
    },
    {
        path: '/:lang?/contacts',
        name: 'contacts',
        component: () => import('@/modules/contacts/index.vue'),
    },

    {
        path: '/:lang?/server-not-found',
        name: 'server-not-found',
        component: () => import('@/modules/server-not-found/index.vue'),
    },
    {
        path: '/:lang?/basket',
        name: 'basket',
        component: () => import('@/modules/basket/index.vue'),
    },
    {
        path: '/:lang?/basket/order',
        name: 'order',
        component: () => import('@/modules/basket/components/order/index.vue'),
    },
    {
        path: '/:lang?/card/:slug',
        name: 'card',
        component: () => import('@/modules/card/index.vue'),
    },
    {
        path: '/:lang?/user',
        name: 'user',
        component: () => import('@/modules/user-info/index.vue'),
        redirect: '/user/info',
        children: [
            {
                path: '/:lang?/user/orders',
                name: 'current-order',
                component: () => import('@/modules/user-info/modules/current-order/index.vue'),
            },
            {
                path: '/:lang?/user/history-orders',
                name: 'history-orders',
                component: () => import('@/modules/user-info/modules/orders/index.vue'),
            },
            {
                path: '/:lang?/user/info',
                name: 'userInfo',
                component: () => import('@/modules/user-info/modules/user/index.vue'),
            }
        ]

    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        let el = document.querySelector('.app');
        if (to.path !== from.path) {
            if (savedPosition) {
                return savedPosition
            } else {
                el.scrollTop = 0;

                return {x: 0, y: 0}
            }
        }
    }
});

export default router
